import idx from 'idx';
import * as React from 'react';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import Button from 'components/Button';
import RESEND_PENDING_SMS_DEVICE_VERIFICATION_NOTIFICATION from './mutations/ResendPendingSmsDeviceVerificationNotification.gql';
import {
  ResendPendingSmsDeviceVerificationNotification,
  ResendPendingSmsDeviceVerificationNotificationVariables,
} from './mutations/__generated__/ResendPendingSmsDeviceVerificationNotification';
import { Mutation } from 'react-apollo';
import { ApolloError } from 'apollo-client';
import ToastActions from 'actions/ToastActions';

type Props = {
  deviceId: number;
  resend: (id: number) => Promise<ResendPendingSmsDeviceVerificationNotification>;
};

type State = {
  error: Error | null;
  resent: boolean;
  resending: boolean;
};

class PendingDeviceResendVerification extends React.Component<Props, State> {
  state: State = {
    error: null,
    resent: false,
    resending: false,
  };

  resend = () => {
    this.setState({ resending: true, error: null });

    this.props
      .resend(this.props.deviceId)
      .then(
        () => this.setState({ resending: false, resent: true }),
        error => this.setState({ resending: false, resent: false, error })
      );
  };

  render() {
    if (this.state.resent) {
      return <span>Verfication link was successfully resent.</span>;
    }

    if (this.state.error) {
      return <span>Oops, an error happened: {this.state.error.toString()}.</span>;
    }

    return (
      <Button disabled={this.state.resending} onClick={this.resend}>
        Resend verification link.
      </Button>
    );
  }
}

type MutationProps = {
  deviceId: number;
};

type ResendMutationInVariables = {
  variables: ResendPendingSmsDeviceVerificationNotificationVariables;
};

type ResendMutation = (
  input: ResendMutationInVariables
) => Promise<ResendPendingSmsDeviceVerificationNotification>;

const PendingDeviceResendVerificationWithMutation = (props: MutationProps) => {
  const { deviceId } = props;
  return (
    <Mutation
      mutation={RESEND_PENDING_SMS_DEVICE_VERIFICATION_NOTIFICATION}
      onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}>
      {(resendPendingSmsDeviceVerificationNotification: any) => (
        <PendingDeviceResendVerification
          deviceId={deviceId}
          resend={(id: number) =>
            resendPendingSmsDeviceVerificationNotification({ variables: { id } })
          }
        />
      )}
    </Mutation>
  );
};

export { PendingDeviceResendVerification };
export default PendingDeviceResendVerificationWithMutation;
